import React from 'react'
import "./About.css"
import profilePic from '../images/kheyre.jpeg'
import Fade from 'react-reveal/Slide';
import Flip from 'react-reveal/Slide';

function About() {
    return (
        <div className="con" id='about'>
            <div className="container about-section">
                <div className="row">
                    <Fade bottom>
                        <div className="col-xl-6 col-lg-md-12 col-sm-12">
                            <div className="about-image">
                                <img src={profilePic} alt="profile photo" />
                            </div>
                        </div>
                    </Fade>

                    <div className="col-xl-6 col-lg-md-12 col-sm-12">
                        <div className="about-details">

                            <Flip left>
                                <div className="about-titel">
                                    <h5>About Me</h5>
                                    <span className='line'></span>
                                </div>
                            </Flip>


                            <Fade bottom>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    when an unknown printer took a galley of type and scrambled it to make a type
                                    specimen book. It has survived not only five centuries, but also the leap into
                                    electronic typesetting, remaining essentially unchanged. It was popularised in
                                    the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
                                    and more recently with desktop publishing software like Aldus PageMaker including
                                    versions of Lorem Ipsum.</p>
                            </Fade>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default About